import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  driveremergencyinfo: [],
  driverAcceptFlag: false,
  driverAcceptClick: false,
  driverOfflineFlag: false,
  navigationflag: true,
  clientId: '',
  dpositioninfo:'',
  driverstatusupdate:false
};
export default function driveremergencyReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_DRIVEREMERGENCY_INFO:
      return (assign({}, state, {
        driveremergencyinfo: action.driveremergencyinfo
      }));
      case types.DRIVER_POSITION:
      return (assign({}, state, {
        dpositioninfo: action.dpositioninfo
      }));
      case types.DRIVER_STATUS_UPDATE_FLAG:
      return (assign({}, state, {
        driverstatusupdate: action.driverstatusupdate
      }));
      case types.DRIVER_ACCEPT_FLAG:
      return (assign({}, state, {
        driverAcceptFlag: action.driverAcceptFlag,
        clientId:action.clientId,
        driverAcceptClick: action.driverAcceptClick
      }));
      case types.NAVIGATION_FLAG:
      return (assign({}, state, {
        navigationflag: action.navigationflag
      }));
      case types.DRIVER_OFFLINE_FLAG:
      return (assign({}, state, {
        driverOfflineFlag: action.driverOfflineFlag
      }));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/driveremergencyReducer.js